import Vue from 'vue';

export default class UserResource {

  favorites = null;

  getSearchHistoryLocalStorage() {
    let result = localStorage.getItem("search-history");
    if (!result) {
      return [];
    }
    else {
      try {
        let jsonHistory = JSON.parse(result);
        if (jsonHistory) return jsonHistory;
      }
      catch (err) {
        Vue.$log.error(err);
        localStorage.removeItem("search-history");
        return [];
      }
    }
  }

  setSearchHistoryLocalStorage(history) {
    localStorage.setItem("search-history", JSON.stringify(history.slice(0,20)));
  }

  filterSearchHistoryLocalStorage(history, searchText, searchType) {
    return history.filter(item => item.searchType !== searchType || item.searchText !== searchText);
  }

  async addToSearchHistory(searchText, searchType) {

    let history = this.getSearchHistoryLocalStorage();
    history = this.filterSearchHistoryLocalStorage(history, searchText, searchType);
    history.unshift({searchType:searchType, searchText:searchText, timestamp: Date.now()});
    this.setSearchHistoryLocalStorage(history);

  }

  async getSearchHistory() {

    let history = this.getSearchHistoryLocalStorage();
    return history;

  }

}
